import axios from "axios";
import { queryCache } from "react-query";

import { STORAGE_KEYS, URI } from "../../utils/constants";
import { QUERY_AUTH } from "./queries";

export const loginUser = (payload) =>
  Promise.resolve()
    .then(() => queryCache.removeQueries(QUERY_AUTH.queryKey))
    .then(() => axios.post(`${URI.API}/auth/local`, payload))
    .then(({ data }) => {
      localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, data.jwt);
      queryCache.setQueryData(QUERY_AUTH.queryKey, data.user);
    });

export const resetPassword = (email) => {
  const payload = {
    email,
    url: `${URI.API}/admin/plugins/users-permissions/auth/reset-password`,
  };

  return axios.post(`${URI.API}/auth/forgot-password`, payload);
};
